import { createClient } from '@supabase/supabase-js'

// Für den Cutover VITE_SUPABASE_BACKEND=coolify und BEIDE VITE_SUPABASE_* Werte setzen.
// Ohne explizite Umschaltung bleibt das produktive Cloud-Projekt unverändert.
const USE_COOLIFY = import.meta.env.VITE_SUPABASE_BACKEND === 'coolify'
const CLOUD_SUPABASE_URL = 'https://srisdwacanguppnfiowc.supabase.co'
const CLOUD_SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNyaXNkd2FjYW5ndXBwbmZpb3djIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODMzMjc4MzYsImV4cCI6MjA5ODkwMzgzNn0.KRFHgjTd8NH199AUTQ_TITG_YdA3jsfEvRjVooYmmLo'
const SUPABASE_URL = USE_COOLIFY
  ? import.meta.env.VITE_SUPABASE_URL?.trim().replace(/\/$/, '')
  : CLOUD_SUPABASE_URL
const SUPABASE_ANON_KEY = USE_COOLIFY
  ? import.meta.env.VITE_SUPABASE_ANON_KEY?.trim()
  : CLOUD_SUPABASE_ANON_KEY

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error('Missing Coolify Supabase URL or public API key. Production cutover blocked.')
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
  },
})
